<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <PageHeader title="Account" subtitle="Update your user information">
            </PageHeader>

            <div class="sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10">
              <div class="row">
                <div class="col-sm-12 col-md-6">

                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-12 col-sm-6 col-form-label" for="txtName">Name</label>
                    <div class="col-xs-12 col-sm-6">
                      <div class="row">
                        <div class="col-xs-6">
                          <input type="text" id="txtName" class="form-control" v-model="user.firstName" placeholder="First name" />
                        </div>
                        <div class="col-xs-6">
                          <input type="text" id="txtLName" class="form-control" v-model="user.lastName" placeholder="Last name" />
                        </div>
                      </div>
                    </div>
                  </div>

                </div><!-- /.col -->
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">

                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-12 col-sm-6 col-form-label" for="txtEmail">Email address</label>
                    <div class="col-xs-12 col-sm-6">
                      <input type="email" id="txtEmail" class="form-control" v-model="user.email" />
                    </div>
                  </div>

                </div><!-- /.col -->
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">

                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-12 col-sm-6 col-form-label" for="txtNewPass">New password</label>
                    <div class="col-xs-12 col-sm-6">
                      <input type="password" id="txtNewPass" class="form-control" v-model="user.password" />
                    </div>
                  </div>
                  <div class="setting form-group row form-group-sm">
                    <label class="col-xs-12 col-sm-6 col-form-label" for="txtConfirmPass">Confirm password</label>
                    <div class="col-xs-12 col-sm-6">
                      <input type="password" id="txtConfirmPass" class="form-control" v-model="user.password_confirmation" />
                    </div>
                  </div>

                </div><!-- /.col -->
              </div><!-- /.row -->

              <div class="row">
                <div class="col-xs-12 col-md-6 text-right">
                  <button class="btn btn-primary btn-lg" v-on:click="save">Save</button>
                </div>
              </div>
            </div><!-- /.main-content -->
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    components: {

    },

    created() {
      this.$store.commit(`CLEAR_USER_ERRORS`);
      this.user.email = this.currentUser.email;
      this.user.firstName = this.currentUser.firstName;
      this.user.lastName = this.currentUser.lastName;
    },

    methods: {
      save: function (event) {

        if (!this.user.email) {
          Toast.error('You must enter an email address');
          return;
        }

        if (this.user.password != this.user.password_confirmation) {
          Toast.error('Password fields must match');
          return;
        }

        let changes = { first_name: this.user.firstName, last_name: this.user.lastName }
        if (this.user.email) { changes.email = this.user.email; }
        if (this.user.password) { changes.password = this.user.password; }
        
        this.$store.dispatch('updateUser', {
          changes,
          callback: (err) => {
            if (err) {
              Toast.error(err[0]);
            } else {
              Toast.success('Account updated successfully');
            }
          },
        })
      }
    },

    computed: {
      ...mapState([
        'currentUser',
      ])
    },

    data() {
      return {
        user: {
          email: null,
          password: null,
          password_confirmation: null,
          firstName: '',
          lastName: '',
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// account.vue?36032831